import { render, staticRenderFns } from "./saleitem.vue?vue&type=template&id=315fa7fc&"
import script from "./saleitem.vue?vue&type=script&lang=js&"
export * from "./saleitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports